import React, { useState } from "react";
import { getDefaultProfilePicUrl, getProfilePicUrl } from "@my-dld/utils/PathUtils";
import { picCache } from "@my-dld/screens/MyDLD/MyProfile";

export function ProfileImage() {
	const [ avatarUrl, setAvatarUrl ] = useState( getProfilePicUrl() );
	const onImageError = ( e: React.SyntheticEvent<HTMLImageElement> ) => {
		setAvatarUrl( getDefaultProfilePicUrl() );
	};
	document.addEventListener( "profile_image_updated", () => {
		setAvatarUrl( getProfilePicUrl() );
	} );

	return <img
		width={ 85 }
		height={ 85 }
		sizes={ "100" }
		onError={ onImageError }
		src={ avatarUrl + "?cacheId=" + picCache.cacheId }
	/>;
}
